export {VscodeCollapsible} from './vscode-collapsible.js';
